import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Potwierdź adres e-mail',
  [OnboardingStep.BusinessInfo]: 'Dodaj dane sklepu',
  [OnboardingStep.PersonalInfo]: 'Dodaj dane osobowe',
  [OnboardingStep.ShippingInfo]: 'Dodaj dane dostawy',
  [OnboardingStep.BankInfo]: 'Dodaj dane bankowe do wypłat',
  [OnboardingStep.TaxInfo]: 'Czy Twoja firma jest płatnikiem VAT?',
  [OnboardingStep.BusinessDocs]: 'Dokument potwierdzający działalność',
  [OnboardingStep.PersonalDocs]: 'Dokument tożsamości',
  [OnboardingStep.InfoSubmission]: 'Otrzymaj płatność',
  confirm_info_gateway: 'Otrzymaj płatność – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informacje o płatności',
  [OnboardingStep.Subscription]: 'Subskrypcja',
  [OnboardingStep.MobileApp]: 'Aplikacja mobilna',
  [OnboardingStep.DeliveryStructure]: 'Struktura dostawy',
  [OnboardingStep.Contract]: 'Umowa',
  [OnboardingStep.ContractPayment]: 'Płatność za umowę',
  [OnboardingStep.PromoCode]: 'Kod promocyjny',
};
